function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  stroke: "#000",
  strokeWidth: 0.2,
  d: "M1.29.139a.257.257 0 0 0-.258.258v1.79a.257.257 0 0 0 .258.257h.396v8.58a.257.257 0 0 0 .258.257h3.498l-1.755 3.223a.257.257 0 1 0 .448.247l1.892-3.47h1.881v3.344a.258.258 0 1 0 .516 0V11.28h1.887l1.887 3.47a.258.258 0 1 0 .453-.247l-1.76-3.223h3.498a.257.257 0 0 0 .258-.258V2.444h.395a.257.257 0 0 0 .258-.258V.396a.257.257 0 0 0-.258-.257H1.29zm.258.516H14.79v1.273H1.548V.655zm.654 1.79H14.13v8.32H2.202v-8.32zm6.87 2.37c.007.13.11.236.241.244H11L8.166 8.041 6.71 6.585a.257.257 0 0 0-.35-.006L4.553 8.213a.26.26 0 1 0 .35.385L6.52 7.124 7.99 8.586a.257.257 0 0 0 .367-.006l2.993-3.142v1.657a.258.258 0 1 0 .516 0V4.807a.257.257 0 0 0-.258-.258H9.29a.257.257 0 0 0-.217.265z"
});

var SvgReportsSvg = function SvgReportsSvg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReportsSvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reportsSvg.2d7a621a.svg";
export { ForwardRef as ReactComponent };